import { Button, DatePicker, Input, Modal, Select, Table } from 'antd'
import { Option } from 'antd/es/mentions'
import React, { useState, useEffect } from 'react'
 import "../MainCSS.css";
import 'aos/dist/aos.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import TextArea from 'antd/es/input/TextArea'
import { ChangeStatusOfJobWork, DeletePackingJobWorkData, GenerateDispatchNo, GenerateJobWorkNo, GetDispatchDataByMonth, GetDispatchDetails, GetDispatchPackingDetails, GetJobWorkDetails, GetJobWorkPackingDetails, SaveDispatchDetails, SaveJobWork, SelectedJobWorkDetails, UpdateDispatchDetails } from '../../AllAPI/DispatchAPI/DispatchApi';
import dayjs from 'dayjs';
import { GetWorkerMaster } from '../../AllAPI/MasterAPI/GeneralMasterApi';

const JobWork = () => {
  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {}
  // const storedUserData = sessionStorage.getItem('userData') || '';

  const commonHeaders = {
    headers: {
      // createdBy: storedUserData || '',
      // updatedBy: storedUserData || '',
      createdBy: 1,
      updatedBy: 2,
      userIp: storedHeaders.userIp || '',
      userLat: storedHeaders.userLat || '',
      userLong: storedHeaders.userLong || '',
      deviceSign: storedHeaders.deviceSign || '',
    },
  }

  const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }




    const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']


  const [packingId, setPackingId] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false);
    const [JobWorkId, setJobWorkId] = useState('')

   const [JobWorkNo, setJobWorkNo] = useState('');
  const [dispatchDate, setDispatchDate] = useState('');// or moment() for default current date
const[allWorker,setAllWorker]=useState([]);
  const [totalWeight, setTotalWeight] = useState('');
  const [vehicleNo, setVehicleNo] = useState('');
  const [remark, setRemark] = useState('');
    const [vehicleNumberM, setVehicleNumberM] = useState('');
    const[jobWorker ,setJobWorker]= useState('');
  const [remarkM, setRemarkM] = useState('');
 
  const [errors, setErrors] = useState({
   packingId,
   remark,
   vehicleNo,
   totalWeight,
   dispatchDate,
   JobWorkNo,
   jobWorker,
  })
  const [errorsM, setErrorsM] = useState({
   vehicleNumberM,
   remarkM,
  })
  // Fetch OrderEntry, Customer and Item Names
  let isJobWorkDataFetched = false
  useEffect(() => {
    if (isJobWorkDataFetched) return
  generateJobWorkNumber();
  fetchWorker();
  
    isJobWorkDataFetched = true
  }, [])
// useEffect(() => {
//   // Check if packingId is cleared (empty string or less than 13 characters)
//   if (packingId.trim() === '') {
//     handleJobWorkCancel();
//   } else {
//     // If packingId has 13 or more characters, fetch data
//     if (packingId.trim().length >= 10 && !isJobWorkDataFetched) {
//       fetchPackingData();
//     }
//   }

//   // Mark the JobWork data as fetched to prevent redundant fetch calls
//   isJobWorkDataFetched = true;
// }, [packingId]);
useEffect(() => {
  if (packingId.trim() === '') return;

  const alreadyExists = PackingData.some(item => item.packingId === packingId.trim());

  if (packingId.trim().length >= 10 && !alreadyExists) {
    fetchPackingData();
    handleCancel();
  }
}, [packingId]);


  //=========================================
  let isError = false


  const fetchWorker = async () => {
    try {
      const response = await axios.get(GetWorkerMaster,commonHeaders1);
      if (response.data !== null) {
        setAllWorker(response.data);
        
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Worker:", error);
        toast.error("Failed to fetch Worker data");
        isError = true; 
      }
    }
  };
 

  // 3. Submit Button=======================================================================
  const handleJobWorkSubmit = async () => {
    let isValid = true
    const errorObj = {}

  if (!vehicleNo) {
    isValid = false;
    errorObj.vehicleNo = "Vehicle Number is required";
  }
  if (!dispatchDate) {
  isValid = false;
  errorObj.dispatchDate = "Dispatch Date is required";  
}

  if (!remark) {
    isValid = false;
    errorObj.remark = "Remark is required";
  }   if (!packingId) {
    isValid = false;
    errorObj.packingId = "Packing ID is required";
  }
   if (!jobWorker) {
    isValid = false;
    errorObj.jobWorker = "Packing ID is required";
  }


    setErrors(errorObj) // Set error messages

    if (!isValid) return
  const allPackingIds = PackingData.map(item => item.packingId);
    const payload = {
      jobWorkNumber: JobWorkNo,
  packingIds:allPackingIds,
  totalwt: totalWeight,
  vehicleNumber: vehicleNo,
  remark: remark,
  jobWorkerId:jobWorker,
    }

    try {
      const response = await axios.post(
        SaveJobWork,
        payload,
        commonHeaders,
      )
     
      if (response.data == 'CREATED') {
        toast.success('Data submitted successfully!')
        handleJobWorkCancel();
        generateJobWorkNumber();
        
      }
      else if (response.data == "ALREADYEXISTED") {
        toast.warn('Data Already Exist!')
      }
    } catch (err) {
      console.error('Error submitting data', err)
    }
  }
const   handleJobWorkCancel = () =>{
  setDispatchDate("");
  setVehicleNo("");
  setRemark("");
  setTotalWeight("");
  setPackingId("");
  setJobWorker("");
  setPackingData([]);
  setFilteredData1([]);
  setTotalEntries1(0);
}
const handleCancel =() =>{
    setDispatchDate("");
  setVehicleNo("");
  setRemark("");
    setJobWorker("");

}
  //===========================================
  const unitOptions = [
    { value: '1', label: 'FT' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'INCH' },
  ]

  //===============================================

  //======Todays JobWork Details Data Table===============

  const [JobWorkData, setJobWorkData] = useState([]);
    const [SelectedJobWorkData, setSelectedJobWorkData] = useState([])

  const [filteredData, setFilteredData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = JobWorkData.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  const fetchJobWorkData = async () => {
    try {
      const response = await axios.get(GetJobWorkDetails, commonHeaders1)
     const JobWorkDetails = response.data;

    if (!JobWorkDetails) {
      toast.error("Failed to fetch order details.");
      return;
    }

    if (Array.isArray(JobWorkDetails) && JobWorkDetails.length > 0) {
      setJobWorkData(JobWorkDetails);
      setFilteredData(JobWorkDetails);
      setTotalEntries(JobWorkDetails.length);
      setShowTable(true);
    } else {
      toast.warn("No Job Work Data available.");
      setJobWorkData([]);
      setFilteredData([]);
      setTotalEntries(0);
      setShowTable(false);
    }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching  JobWork Data:', error)
        toast.error('Failed to fetch  JobWork Data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

 
const columns = [
  
  {
    title: 'JobWork No.',
    dataIndex: 'jobWorkNumber',
    key: 'jobWorkNumber',
    sorter: (a, b) => String(a.jobWorkNumber ?? '').localeCompare(String(b.jobWorkNumber ?? '')),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    sorter: (a, b) => (a.customerName || '').toString().localeCompare((b.customerName || '').toString()),
  },

    {
    title: 'Order No.',
    dataIndex: 'orderNumbers',
    key: 'orderNumbers',
    sorter: (a, b) => String(a.orderNumber ?? '').localeCompare(String(b.orderNumber ?? '')),
  },
   {
    title: "PO Number",
    dataIndex: "poNumber",
    key: "poNumber",
    sorter: (a, b) => (a.poNumber || '').toString().localeCompare((b.poNumber || '').toString()),
  },
  {
    title: "PO Date",
    dataIndex: "poDate",
    key: "poDate",
    sorter: (a, b) => (a.poDate || '').toString().localeCompare((b.poDate || '').toString()),
  },
    {
    title: 'Disp Date',
    dataIndex: 'dispatchDate',
    key: 'dispatchDate',
    sorter: (a, b) => new Date(a.dispatchDate) - new Date(b.dispatchDate),
  },
  {
    title: 'Vehicle Number',
    dataIndex: 'vehicleNumber',
    key: 'vehicleNumber',
    sorter: (a, b) => String(a.vehicleNumber ?? '').localeCompare(String(b.vehicleNumber ?? '')),
  },
 {
    title: 'Remark',
    dataIndex: 'remark',
    key: 'remark',
    sorter: (a, b) => String(a.remark ?? '').localeCompare(String(b.remark ?? '')),
  },
  //    {
  //   title: 'Total Bundles',
  //   dataIndex: 'totalBundles',
  //   key: 'totalBundles',
  //   render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
  //   sorter: (a, b) => (a.totalBundles ?? 0) - (b.totalBundles ?? 0),
  // },
   {
    title: 'Total Weight',
    dataIndex: 'totalWeight',
    key: 'totalWeight',
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    sorter: (a, b) => (a.totalWeight ?? 0) - (b.totalWeight ?? 0),
  },
  {
    title: 'Job Worker Name',
    dataIndex: 'jobWorker',
    key: 'jobWorker',
    sorter: (a, b) => String(a.jobWorker ?? '').localeCompare(String(b.jobWorker ?? '')),
  },
  
 
 
    {
    title: 'Action',
    key: 'action',
    render: (text, record) => (
        <button type='primary'  className="CancelBtn" onClick={() => handleViewData(record)}>View</button>
    ),
  },
   {
    title: 'Print',
    key: 'print',
    render: (_, record) => (
        <div>
    
        <span
          type="button"
          style={{ fontSize: "14px", color: "#52c41a", cursor: "pointer" }}
           onClick={() => handlePrint(record)}
          title="Print"
        >
          <i className="fa-solid fa-print"></i>
        </span>
      </div>
    ),
  },

];




  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023e7d',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
                        fontSize: '15px',

          }}
        >
          {children}
        </td>
      ),
    },
  }

   //======Todays JobWork Details Data Table===============

   const [PackingData, setPackingData] = useState([])
   const [filteredData1, setFilteredData1] = useState([])
   const [pageSize1, setPageSize1] = useState(10)
   const [currentPage1, setCurrentPage1] = useState(1)
   const [totalEntries1, setTotalEntries1] = useState(0)
 
 
   const handleSearch1 = (value) => {
     const searchValue = value.toLowerCase();
   
     const filtered = PackingData.filter((item) =>
       Object.values(item).some((val) =>
         String(val ?? "").toLowerCase().includes(searchValue)
       )
     );
   
     setFilteredData1(filtered);
     setTotalEntries1(filtered.length);
     setCurrentPage1(1);
   };
   
 
   const handlePageSizeChange1 = (value) => {
     setPageSize1(value)
   }
 
   const fetchPackingData = async () => {
     try {
      const response = await axios.get(`${GetJobWorkPackingDetails}?packingId=${packingId}`, commonHeaders1)
     
           if(response.data === 'NOTALLOCATED'){
              toast.warn("Not Allocated ");
            }
//if (Array.isArray(response.data) && response.data.length > 0) {
              // setPackingData(response.data);
              // setFilteredData1(response.data);
              // setTotalEntries1(response.data.length);
              // setTotalWeight(response.data[0].netWeight);  // Correct way
              // console.log("Total Weight", response.data[0].netWeight);
                 if (Array.isArray(response.data) && response.data.length > 0) {
                    const newData = response.data;
              
                    // Check for duplicates based on packingId
                    const existingIds = new Set(PackingData.map(item => item.packingId));
                    const uniqueData = newData.filter(item => !existingIds.has(item.packingId));
              
                    if (uniqueData.length === 0) {
                      toast.info("Packing ID already added.");
                      return;
                    }
              
                    //const updatedData = [...PackingData, ...uniqueData];//  prepend old data
              const updatedData = [...uniqueData, ...PackingData]; // ✅ New data first, old data after

                    setPackingData(updatedData);
                    setFilteredData1(updatedData);
                    setTotalEntries1(updatedData.length);
          
                    // // Total weight = sum of netWeight for all entries
                    const totalWeight = updatedData.reduce((sum, item) => sum + (item.netWeight || 0), 0);
                    setTotalWeight(totalWeight.toFixed(2));
    JobWorkStatusChange();
            }
     } catch (error) {
       if (!isError) {
         console.error('Error fetching Data:', error)  
         toast.error('Failed to fetch Data')
         isError = true // Set the flag to prevent double toast
       }
     }
   }
 
 const columns1 = [
  {
    title: 'Sr No.',
    key: 'index',
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'Order ID',
    dataIndex: 'orderNumber',
    key: 'orderNumber',
    sorter: (a, b) => (a.orderNumber ?? '').toString().localeCompare((b.orderNumber ?? '').toString()),
  },
  {
    title: 'Customer Name',
    dataIndex: 'customerName',
    key: 'cuatomerName',
    sorter: (a, b) => (a.partyName ?? '').localeCompare(b.partyName ?? ''),
  },
  {
    title: 'Pack ID',
    dataIndex: 'packingId',
    key: 'packingId',
    sorter: (a, b) => (a.packingId ?? '').localeCompare(b.packingId ?? ''),
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => (a.dieName ?? '').localeCompare(b.dieName ?? ''),
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
    sorter: (a, b) => (a.alloyName ?? '').localeCompare(b.alloyName ?? ''),
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
    sorter: (a, b) => (a.temperName ?? '').localeCompare(b.temperName ?? ''),
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    align: 'right',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
  },
  {
    title: 'Pcs',
    dataIndex: 'pcs',
    key: 'pcs',
    align: 'right',
    sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
  },
  {
    title: 'Weight',
    dataIndex: 'netWeight',
    key: 'netWeight',
    align: 'right',
    sorter: (a, b) => (a.netWeight ?? 0) - (b.netWeight ?? 0),
  },
  {
    title: 'Wt. Range',
    dataIndex: 'weightRange',
    key: 'weightRange',
    align: 'right',
    sorter: (a, b) => (a.weightRange ?? 0) - (b.weightRange ?? 0),
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (_, record) => (
      <Button danger size="small" 

      onClick={() => handleDelete(record)}
      >
        Delete
      </Button>
    ),
  },
];



 
   const components1 = {
     header: {
       cell: ({ children, ...restProps }) => (
         <th
           {...restProps}
           style={{
             backgroundColor: '#000',
             color: '#fff',
             padding: '10px',
             fontSize: '15px',
             borderRadius: '0px',
           }}
         >
           {children}
         </th>
       ),
     },
     body: {
       row: ({ children, ...restProps }) => (
         <tr
           {...restProps}
           style={{
             backgroundColor: '#f0f7fd',
           }}
         >
           {children}
         </tr>
       ),
       cell: ({ children, ...restProps }) => (
         <td
           {...restProps}
           style={{
             padding: '8px',
                         fontSize: '15px',

           }}
         >
           {children}
         </td>
       ),
     },
   }

  //===============================================

   
   
//==================== View Data According to Month =============================================================================
const [selectedMonth, setSelectedMonth] = useState(null);
const [showTable, setShowTable] = useState(false);

// Your fetch logic
const handleViewData = async (record) => {

  try {


    const response = await axios.get(
      `${SelectedJobWorkDetails}?jobWorkNumber=${record.jobWorkNumber}`,
      commonHeaders1
    );

    const JobWorkDetails = response.data;

    if (!JobWorkDetails) {
      toast.error("Failed to fetch order details.");
      return;
    }

    if (Array.isArray(JobWorkDetails) && JobWorkDetails.length > 0) {
      setSelectedJobWorkData(JobWorkDetails);
      setIsModalVisible(true);
    } else {
      toast.warn("No items found.");
      setJobWorkData([]);
      setIsModalVisible(false);
    }
  } catch (error) {
    console.error("Error during API call:", error);
    toast.error("Error occurred while submitting data");
  }
};
//======================== Generate JobWork No. ==========================================
const generateJobWorkNumber = async () => {
  try {
   const response = await axios.get(GenerateJobWorkNo, commonHeaders1);

    if (response.data) {
      setJobWorkNo(response.data); // assuming the API returns a plain string
      console.log("JobWork Number:", response.data);
    }
  } catch (error) {
    console.error("Error generating JobWork number:", error);
    toast.error("Failed to generate JobWork number");
  }
};
//=================================== Status Change =========================================================================
const JobWorkStatusChange = async () => {
  try {
    const response = await axios.post(`${ChangeStatusOfJobWork}?packingId=${packingId}`, {} ,commonHeaders);
    if (response.data ==='UPDATED') {
    console.log("Status Changed");
    }
    else if(response.data ==='NOTFOUND'){
     toast.warn(" Data Not Found");
    }
  } catch (error) {
    console.error("Error while changing Status:", error);
  
  }
};
//=================================== Delete Data that is sne to dispatch ==================================
    const handleDelete = async (item) => {
      const confirmDelete = window.confirm(
        `Are you sure you want to delete ?`
      );
      if (!confirmDelete) return;
    
      try {
        const response = await axios.post(`${DeletePackingJobWorkData}?packingId=${item.packingId}`,{},commonHeaders1);
        if (response.data === "DELETED") {
          toast.success(" Deleted successfully!");
          fetchPackingData();
          handleCancel();
        }
          const updatedData = PackingData.filter(p => p.packingId !== item.packingId);
      setPackingData(updatedData);
      setFilteredData1(updatedData);

      const updatedWeight = updatedData.reduce((sum, p) => sum + (p.netWeight || 0), 0);
      setTotalWeight(updatedWeight.toFixed(2));
      } catch (error) {
        console.error("Error during delete operation:", error);
        toast.error("Error occurred while deleting");
      }
    };
//==================================================== Print Report Modal================================================================================================
        const [includeRate, setIncludeRate] = useState("2"); 
        const[reportType,setReportType]= useState("1"); 
        const[isPrintModalVisible,setIsPrintModalVisible]=useState(false);
        const[dispatchOrder ,setDispatchOrder]=useState("");
          const handlePrint = async (item) => {      
        setDispatchOrder(item);
        console.log("Dispatch Order",dispatchOrder);
          setIsPrintModalVisible(true);
        };
    
        const handleViewReport = () => {
      console.log("Viewing Report", {
        JobWorkNo,
        reportType,
        includeRate
      });
      // Optional: Call API or navigate to report view
    };
const jobWorkColumns = [
  {
    title: "Job Work Number",
    dataIndex: "jobWorkNumber",
    key: "jobWorkNumber",
  },
  {
    title: "Order Number",
    dataIndex: "orderNumber",
    key: "orderNumber",
  },

  {
    title: "Packing ID",
    dataIndex: "packingId",
    key: "packingId",
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
  },

  {
    title: "Item Name",
    dataIndex: "dieName",
    key: "dieName",
  },
  {
    title: "Length",
    dataIndex: "length",
    key: "length",
  },

  {
    title: "Pcs",
    dataIndex: "pcs",
    key: "pcs",
  },
  {
    title: "Weight",
    dataIndex: "netWeight",
    key: "netWeight",
  },
  {
    title: "W/R",
    dataIndex: "weightRange",
    key: "weightRange",
  },
];
//============================== Print Report ================================================================
  // const handleShowPdf = async () => {
  //   let isValid = true
  //   const errorObj = {}

  //   if (rackNo) {
  //     isValid = false
  //     errorObj.rackNo = 'Rack No. is required *'
  //   }

  //   setErrors(errorObj)
  //   if (!isValid) return

  //   const url = `${GetRackReleaseReportData}?rackNo=${rackNo}`

  //   try {
  //     const response = await axios.get(url, commonHeaders1)

  //     if (response.data !== null) {
  //       if (
  //         response.data === 'NOTFOUND' ||
  //         response.data === 'NODATA' ||
  //         response.status === 204
  //       ) {
  //         toast.warn('No data available!', {
  //           position: 'top-right',
  //           autoClose: 2000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         })

  //         setLoading(false)
  //         return // Exit function early
  //       }
  
  //       let reportUrl = response.data
  //       if (reportUrl === 'NOTFOUND') {
  //         toast.warn('Report File Not Found...!!', {
  //           position: 'top-right',
  //           autoClose: 2000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         })
  //       } else {
  //         const reportLink = BaseIPForPDF + `output/${reportUrl}`
  //         window.open(reportLink, '_blank')
  //       }
  //     }
  //   } catch (error) {
  //     setLoading(false)
  //     console.error('Error during API call:', error)
  //     toast.error('Error occurred while submitting data')
  //   }
  // }
  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
      <div
        className="row mt-3 p-3  pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff' }}
      >
      <div className="col-12">
  <div className="row">
    {/* JobWork No. */}
  <div className="col-12">
  <div className="row gx-2"> {/* Reduce horizontal spacing between columns */}
    {/* JobWork No. */}
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">JobWork No.</label>
      <Input
        className="w-100 compact-input"
        value={JobWorkNo}
        style={{backgroundColor:"#e9e9e9e9"}}
      onChange={(e) => setJobWorkNo(e.target.value)}
        readOnly
      />
    </div>
  
     

    {/* JobWork Date */}
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Dispatch Date</label>
      <DatePicker
        className="w-100 compact-input"
        value={dispatchDate}
        onChange={(date) => setDispatchDate(date)}
          format={dateFormatList}
      />
       {errors.dispatchDate && <div className="errorField">{errors.dispatchDate}</div>}
    </div>
    {/* Total Weight */}
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Total Weight</label>
      <Input
        className="w-100 compact-input"
        value={totalWeight}
      style={{backgroundColor:"#e9e9e9e9"}}

        readOnly
      />
    </div>
       {/* Packing Id */}
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Scan Here</label>
      <Input
        className="w-100 compact-input"
        value={packingId}
        onChange={(e) => setPackingId(e.target.value)}
        placeholder="Enter Packing Id"
        maxLength={250}
      />
            {errors.packingId && <div className="errorField">{errors.packingId}</div>}
    </div>
    <div className="col-md-4 col-lg-4 py-1">
  <label className="labels">Job Worker</label>
  <Select
    showSearch
    placeholder="Select Job Worker"
    optionFilterProp="children"
    className="w-100 compact-input"
    value={jobWorker}
    onChange={(value) => setJobWorker(value)}
    // filterOption={(input, option) =>
    //   option.children.toLowerCase().includes(input.toLowerCase())
    // }
  >
    {allWorker.map((worker) => (
      <Select.Option key={worker.id} value={worker.id}>
        {worker.name}
      </Select.Option>
    ))}
  </Select>
        {errors.jobWorker && <div className="errorField">{errors.jobWorker}</div>}
</div>

  
 
   
 {/* Table */}
  <div className="col-12 py-2"  style={{  backgroundColor: "white" }}>

    <div
                                    className="col-12 px-lg-5"
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                  >
                                    <div>
                                      <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                                      <Select
                                        defaultValue={pageSize1}
                                        onChange={handlePageSizeChange1}
                                        style={{ width: 120, textAlign: "center" }}
                                      >
                                        <Option value={10}>10</Option>
                                        <Option value={20}>20</Option>
                                        <Option value={30}>30</Option>
                                      </Select>
                                    </div>
          
                                    <div className="pt-4 pt-lg-0">
                                      <Input.Search
                                        placeholder="Search"
                                        onChange={(e) => handleSearch1(e.target.value)}
                                        style={{ width: 200, marginBottom: 16 }}
                                      />
                                    </div>
                                  </div>
          
                                  <div style={{ backgroundColor: "white" }}>
                                    <Table
                                      bordered
                                      style={{ padding: "0px 20px", overflowX: "auto" }}
                            columns={columns1}
                    dataSource={filteredData1}
                                      pagination={{
                                        pageSize: pageSize1,
                                        total: totalEntries1,
                                        showTotal: (total, range) =>
                                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                        current: currentPage1,
                                        onChange: (page) => setCurrentPage1(page),
                                      }}
                                      showSorterTooltip={false}
                                      rowKey={(record) => record.orderNumberId}
                                      components={components1}
                                            size="small"
                                    />
                                  </div>

  </div>

    {/* Vehicle No. */}
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Vehicle No.</label>
      <Input
        className="w-100 compact-input"
        value={vehicleNo}
        onChange={(e) => setVehicleNo(e.target.value)}
        placeholder="Enter Vehicle No."
        maxLength={250}
      />
        {errors.vehicleNo && <div className="errorField">{errors.vehicleNo}</div>}
    </div>

    {/* Remark */}
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Remark</label>
      <Input
        className="w-100 compact-input"
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
        placeholder="Enter Remark"
        maxLength={250}
      />
        {errors.remark && <div className="errorField">{errors.remark}</div>}
    </div>

  
    {/* Buttons */}
    <div className="col-12 text-center pt-3">
      <Button
        type="submit"
        className="CancelBtn mx-1"
        onClick={handleJobWorkCancel}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        className="SubmitBtn mx-1"
        onClick={handleJobWorkSubmit}
      >
        Submit
      </Button>
    </div>
  </div>
</div>
</div>
</div>
      </div>



  <div className="row mt-3 p-3 pb-3 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
  <div className="col-12">
          <div className="row p-0 m-0">
            <div className="col-12 pb-3">
              <h5>
                <u>JOB WORK DETAILS</u> -{' '}
              </h5>
               <Button type="primary" onClick={fetchJobWorkData}>
                 View
               </Button>
             
            </div>

          
    </div>
  </div>

{showTable && (
  <div className="row mb-3">
    <div className="col-12 py-3 shadow border rounded" style={{ backgroundColor: 'white' }}>
      <div className="col-12 py-3 px-lg-5" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
          <Select defaultValue={pageSize} onChange={handlePageSizeChange} style={{ width: 120, textAlign: 'center' }}>
            <Option value={10}>10</Option>
            <Option value={20}>20</Option>
            <Option value={30}>30</Option>
          </Select>
        </div>
        <div className="pt-4 pt-lg-0">
          <Input.Search placeholder="Search" onChange={(e) => handleSearch(e.target.value)} style={{ width: 200, marginBottom: 16 }} />
        </div>
      </div>

      <div style={{ backgroundColor: 'white' }}>
        <Table
          bordered
          style={{ padding: '0px 20px', overflowX: 'auto' }}
          columns={columns}
          dataSource={filteredData}
          pagination={{
            pageSize: pageSize,
            total: totalEntries,
            showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
            current: currentPage,
            onChange: (page) => setCurrentPage(page),
          }}
          showSorterTooltip={false}
          rowKey={(record) => record.id}
          components={components}
        />
      </div>
    </div>

    {/* Modal stays outside but inside table visibility block if needed */}
    <Modal
      title="Job Work Details"
      open={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      footer={null}
      width={1000}
    >
    <div className="row">
   <div className="col-12 py-3">
    
      <Table
        columns={jobWorkColumns}
       dataSource={SelectedJobWorkData}
        bordered
        size="small"
        pagination={false}
        components={components1}
        scroll={{ x: "max-content" }}
      />
    </div>
</div>

    </Modal>
        <Modal
      title="Print Dispatch Report"
      open={isPrintModalVisible}
      onCancel={() => setIsPrintModalVisible(false)}
    
        onOk={handleViewReport}
          okText="View Report"
      width={650}
    >
      {/* Dispatch Information */}
      <div className="row mb-3">
         <div className="col-12 col-md-6 py-2">
      <span className="labels">Dispatch No.<strong>{dispatchOrder.dispatchNumber}</strong></span>
      {/* <Input value={dispatchOrder.dispatchNumber} readOnly className="w-100 compact-input" /> */}
    </div>
    <div className="col-12 col-md-6 py-2">
      <span className="labels">Dispatch Date <strong>{dispatchOrder.dispatchDate}</strong></span>
      {/* <Input value={dispatchOrder.dispatchDate} readOnly className="w-100 compact-input" /> */}
    </div>
      </div>
    
      {/* Report Type Selection */}
      <div className="row mb-3">
        <div className="col-12 col-md-6 py-2">
          <label className="labels">Report Type</label>
          <Select
            className="w-100"
            value={reportType}
            onChange={(value) => setReportType(value)}
            placeholder="Select Report Type"
            options={[
              { value: "1", label: 'Summary' },
              { value: "2", label: 'Detailed' },
            ]}
          />
        </div>
    
      <div className="col-12 col-md-6 py-2">
      <label className="labels">Include Rate</label>
      <Select
        className="w-100"
        value={includeRate}
        onChange={(value) => setIncludeRate(value)}
        placeholder="Select Rate Option"
        options={[
          { value: "1", label: 'Yes' },
          { value: "2", label: 'No' },
        ]}
      />
    </div>
    
      </div>
  
    </Modal>
  </div>

)}
</div>

   
    </div>
  )
}

export default JobWork